import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./styles.module.scss";
import { Col, Container, Row } from "react-bootstrap";
import { Description, GridButton, Title } from "@/ui";

export const GridButtonsGrid = ({ className, title, description, items, md, centerTitle }) => {
  if (items.map((i) => i.title).join("").length === 0) {
    return null;
  }

  return (
    <div className={cn(className, styles.grid)}>
      <Container className="mw-lg">
        <Title title={title} className={cn({ "text-center": centerTitle })} />
        <Description description={description} />
        <Row className="d-flex justify-content-center align-items-center">
          {items.map(({ title, img, href, variant }, k) => (
            <Col key={k} md={md} className="p-2">
              <GridButton
                className={variant}
                title={title}
                img={img?.url} // ✅ just the string
                href={href}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default GridButtonsGrid;
